<template>
  <v-app id="getSmsrAll">
    <v-main>
     <v-container fluid>
       <v-row no-gutters>
        <v-card class="px-2">
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
              <td @click="$router.open('/task/guestMessages/smsr/onSmsr/' + props.item.smsr_encrid)"><a> {{props.item.smsr_dt}} </a></td>
              <td><v-chip :color=props.item.smsr_status_kleur>{{props.item.smsr_status}}</v-chip></td>
              
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
    </v-main>
    <navBar title="Ares - Guest messages" :home="true" type="guestmessages"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";

 export default {
  components: {
    navBar,
  },
  data() {
    return {
      items: [],
      search: '',
      headers: [
        {text: 'Date/Time', value: 'smsr_dt'},
        {text: 'Status', value: 'smsr_status'},
      ]
    }  
  },
  mounted() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/task/guestMessages/smsr/getSmsrAll.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getSmsrAll"
          },
          getSmsrAll: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.getSmsrAll;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  }
};

</script> 
